export const fromPattenStringToObject = (input, separatorFromValues = ';', separatorFromKeyToValue = '=') => {
    const result = {};
    const inputSeparatedByValues = input.split(separatorFromValues);
    inputSeparatedByValues.forEach((record) => {
        const [key, value] = record.split(separatorFromKeyToValue);
        if (key && value) {
            result[key] = value;
        }
    });
    return result;
};
//# sourceMappingURL=products.js.map